/**
 * Values for GET /eu/{euId}/state → `data.state`.
 * FE maps this to `profileState` in Redux (historical name).
 *
 * Onboarding / account-connection journey — through `connected`.
 * Deduction / payout setup may also appear as `deduction_setup_*` on the same field.
 * Expense-confirmation progress still lives in `steps` and flags.
 */

export const END_USER_ONBOARDING_STATES = {
  tosConsent: 'tos-consent',
  eSignatureConsent: 'e-signature-consent',
  otpVerified: 'otp-verified',
  profileEnhanced: 'profile-enhanced',
  /** Backend advances here after TCB calc; Connect CTA must still be available. */
  tcbCalculated: 'tcb-calculated',
  connected: 'connected',
} as const;

/** Post-connect deduction/payout setup values on the same `state` field (underscore or hyphen). */
export const END_USER_DEDUCTION_SETUP_STATES = {
  created: 'deduction-setup-created',
  verified: 'deduction-setup-verified',
} as const;

/** Journey states where Home Connect / Retry may be interactive (account not yet connected). */
export const END_USER_CONNECT_READY_STATES = new Set<string>([
  END_USER_ONBOARDING_STATES.profileEnhanced,
  END_USER_ONBOARDING_STATES.tcbCalculated,
]);

/** @deprecated Use `expenseConfirmationConsentAccepted` from the state API instead. */
export const END_USER_EXPENSE_GATE_STATES = {
  tosConsent: 'tos-consent',
} as const;

export type EndUserOnboardingState =
  (typeof END_USER_ONBOARDING_STATES)[keyof typeof END_USER_ONBOARDING_STATES];

export type EndUserJourneyState = EndUserOnboardingState | string;
